import util from '@bmp-vue/core/api/util'
const controller = 'BMPCred'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  NovaOperacaoUnica: function (dto, tipoPessoa) {
    if (tipoPessoa) {
      dto.projeto = window.env.VUE_APP_AMBIENTE + tipoPessoa
    } else {
      dto.projeto = window.env.VUE_APP_AMBIENTE
    }
    return util.Axios.Post(controller + '/NovaOperacaoUnica', dto)
  },
  GetMock (param, documento) {
    const mock = param.MockMotor.find((item) => (item[documento]))
    if (mock) {
      return JSON.parse(mock[documento])
    } else {
      return null
    }
  },
  RelatorioAnaliseMotor (th, dto) {
    const projetosTipoPessoa = th.$aux.ProjetoMotorTipoPessoa
    let projeto = window.env.VUE_APP_AMBIENTE
    if (projetosTipoPessoa.includes(projeto)) {
      projeto = projeto + 'PF'
    }
    dto.projeto = projeto
    return util.Axios.Post(controller + '/DownloadRelatorio', dto)
  }
})
